<template>
  <div class="ba-bg-modal">
    <div class="ba-modal" :class="view">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "onboarding-modal",
  props: ['view']
}
</script>

<style scoped lang="scss">
.ba-bg-modal {

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
  width: 100%;
  height: 93vh;
  background: rgba( 163, 163, 163, 0.25 );
  backdrop-filter: blur( 4px );
  -webkit-backdrop-filter: blur( 4px );

  display: flex;
  align-items: center;
  justify-content: center;

  .ba-modal {
    position: relative;
    gap: 16px;
    flex-shrink: 0;
    background: #FFF;
    border-radius: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/onboarding/components/modal.vue